import { Box, Button, Modal, Typography } from '@mui/material';

import { IConfirmationModalProps } from '../../constants/types';

const modalBoxStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 342,
  bgcolor: 'common.white',
  textAlign: 'center',
  px: 3,
  py: 5,
  borderRadius: 8,
  boxShadow: '4px 4px 16px 8px #10182808',
};

const ConfirmationModal: React.FC<IConfirmationModalProps> = ({
  isOpen,
  message,
  confirmButtonText,
  cancelButtonText,
  setIsOpen,
  onConfirm,
}) => {
  const handleClose = () => setIsOpen(false);

  const handleConfirm = () => {
    onConfirm();
    handleClose();
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="confirmation-modal-title"
      aria-describedby="confirmation-modal-description"
    >
      <Box sx={modalBoxStyle}>
        <Typography
          id="confirmation-modal-title"
          variant="h6"
          sx={{ color: 'tertiary.main', mb: 1.5 }}
        >
          {message}
        </Typography>
        <Button
          variant="contained"
          fullWidth
          onClick={handleConfirm}
          sx={{ mb: 2 }}
        >
          {confirmButtonText}
        </Button>
        <Button
          variant="text"
          color="secondary"
          fullWidth
          onClick={handleClose}
        >
          {cancelButtonText}
        </Button>
      </Box>
    </Modal>
  );
};

export default ConfirmationModal;
